import React, { useLayoutEffect, useState, useRef } from 'react';

interface FieldVisibilityWrapperProps {
    control: any;
    children: React.ReactNode;
}

const FieldVisibilityWrapper: React.FC<FieldVisibilityWrapperProps> = ({ control, children }) => {
    const [hidden, setHidden] = useState<boolean>(!!control?.initiallyHidden);
    const isInitialMount = useRef(true);
    const wrapperRef = useRef<HTMLDivElement>(null);

    // Use useLayoutEffect to handle visibility changes before browser paint
    useLayoutEffect(() => {
        // Skip scroll prevention on initial mount
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }

        if (hidden && control?.visible) {
            setHidden(false);
        }
        if (!control?.visible && control?.initiallyHidden) {
            setHidden(true);
        }
    }, [control?.visible, control?.initiallyHidden, hidden]);

    return (
        <div
            ref={wrapperRef}
            data-initial-hidden={control?.initiallyHidden ? 'true' : 'false'}
            data-control-id={control?._id ?? control?.controlId}
            style={{ display: hidden ? 'none' : undefined }}
            className="field-visibility-wrapper"
        >
            {children}
        </div>
    );
};

export default FieldVisibilityWrapper;
